import AgreementIndex from '../views/agreement/Index.vue';

// 协议页面
export default [
	{
		path: '/agreement',
		name: '隐私协议',
		component: AgreementIndex,
		children: [
			{
				path: 'childPrivacy',
				name: 'childPrivacy',
				desc: '儿童隐私协议',
				component: () => import(/* webpackChunkName: "childPrivacy" */ '../views/agreement/ChildPrivacy.vue'),
				meta: {
					title: '儿童隐私协议',
					backTop: true
				}
			},
			{
				path: 'infoProtection',
				name: 'infoProtection',
				desc: '个人信息保护政策',
				component: () => import(/* webpackChunkName: "infoProtection" */ '../views/agreement/InfoProtection.vue'),
				meta: {
					title: '个人信息保护政策',
					backTop: true
				}
			},
			{
				path: 'infoProtection_huawei',
				name: 'infoProtection_huawei',
				desc: '个人信息保护政策',
				component: () => import(/* webpackChunkName: "infoProtection_huawei" */ '../views/agreement/InfoProtection_Huawei.vue'),
				meta: {
					title: '个人信息保护政策',
					backTop: true
				}
			},
			{
				path: 'userService',
				name: 'userService',
				desc: '用户服务协议',
				component: () => import(/* webpackChunkName: "userService" */ '../views/agreement/UserService.vue'),
				meta: {
					title: '用户服务协议',
					backTop: true
				}
			},
			{
				path: 'thirdServicePrivacy',
				name: 'thirdServicePrivacy',
				desc: '第三方收集个人信息的情况',
				component: () => import(/* webpackChunkName: "thirdServicePrivacy" */ '../views/agreement/ThirdServicePrivacy.vue'),
				meta: {
					title: '第三方收集个人信息的情况',
					backTop: true
				}
			},
			{
				path: 'childSystemPermission',
				name: 'childSystemPermission',
				desc: '脑力大冒险儿童应用系统权限说明',
				component: () => import(/* webpackChunkName: "childSystemPermission" */ '../views/agreement/ChildSystemPermission.vue'),
				meta: {
					title: '脑力大冒险儿童应用系统权限说明',
					backTop: true
				}
			}
		]
	}
];
